module.exports = __webpack_public_path__ + "img/lego-6.98a3f4a2.jpg";